export default "__VITE_ASSET__CXtrhS9P__"